// Test IDs for the admin-managed Application Zones catalog (Configuración).

export const ZONES = {
  card: 'zones-settings-card',
  addButton: 'zones-add-button',
  emptyState: 'zones-empty-state',
  rowPrefix: 'zones-row-', // + zoneId
  nameInputPrefix: 'zones-name-input-',
  categoryCheckboxPrefix: 'zones-category-checkbox-', // + zoneId + '-' + category
  saveButtonPrefix: 'zones-save-button-',
  deleteButtonPrefix: 'zones-delete-button-',
  newNameInput: 'zones-new-name-input',
  newSaveButton: 'zones-new-save-button',
  newCancelButton: 'zones-new-cancel-button',
};
